<div
  class="flex flex-direction-column align-items-center justify-content-center mt-3"
  *ngIf="produtos.length === 0 && showProdutos"
>
  <strong class="gray" style="font-size: 16px;">
    Nenhuma produto de variação adicionado ainda...
  </strong>
</div>

<p-table
  *ngIf="produtos.length && showProdutos"
  [value]="produtos"
  dataKey="posicao"
  editMode="row"
  [resizableColumns]="true"
  [rows]="5"
  [totalRecords]="produtos.length"
  [rowsPerPageOptions]="[5, 10, 15]"
  [paginator]="true"
  styleClass="p-datatable-customers p-datatable-striped container"
  [tableStyle]="{ 'min-width': '1500px' }"
>
  <ng-template pTemplate="caption">
    <span class="flex justify-content-end mb-2" *ngIf="produtos.length">
      Total de <b>&nbsp;{{ produtos.length }}&nbsp;</b> produtos
    </span>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th pResizableColumn class="tr-header" style="width: 15%;">SKU</th>
      <th pResizableColumn class="tr-header">Variação</th>
      <th pResizableColumn class="tr-header" style="width: 20%;">Quantidade</th>
      <th pResizableColumn class="tr-header" style="width: 20%;">
        Valor de venda
      </th>
      <th pResizableColumn class="tr-header" style="width: 0%;"></th>
      <th pResizableColumn class="tr-header" style="width: 0%;">
        <button
          pButton
          pRipple
          type="button"
          icon="pi pi-trash"
          (click)="onRemoveAllProdutosVariacao.emit()"
          class="p-button-rounded p-button-text p-button-danger"
        ></button>
      </th>
    </tr>
  </ng-template>
  <ng-template
    pTemplate="body"
    let-produto
    let-editing="editing"
    let-ri="rowIndex"
  >
    <tr [pEditableRow]="produto">
      <td class="text-center">
        <p-cellEditor>
          <ng-template pTemplate="input">
            <input
              pInputText
              type="text"
              class="input-filters text-center"
              required
              #skuInput
              (click)="skuInput.select()"
              (blur)="checarSKU(produto)"
              [(ngModel)]="produto.sku"
            />
          </ng-template>
          <ng-template pTemplate="output">
            {{ produto.sku ? produto.sku : '-' }}
          </ng-template>
        </p-cellEditor>
      </td>
      <td class="text-center">
        <!-- <p-cellEditor *ngIf="updateRowsVariacao">
          <ng-template pTemplate="input">
            <input
              pInputText
              type="text"
              class="input-filters text-center"
              required
              #descInput
              (click)="descInput.select()"
              [(ngModel)]="produto.descricao"
            />
          </ng-template>
          <ng-template pTemplate="output">
            {{ produto.descricao }}
          </ng-template>
        </p-cellEditor> -->
        <span>
          {{ produto.descricao }}
        </span>
      </td>
      <td class="text-center">
        <p-cellEditor *ngIf="updateRowsVariacao">
          <ng-template pTemplate="input">
            <input
              pInputText
              type="text"
              class="input-filters text-center"
              required
              #qtdInput
              (click)="qtdInput.select()"
              (keydown)="validateOnlyNumbers($event)"
              [(ngModel)]="produto.quantidade"
            />
          </ng-template>
          <ng-template pTemplate="output">
            {{ produto.quantidade }}
          </ng-template>
        </p-cellEditor>
        <span *ngIf="!updateRowsVariacao">
          {{ produto.quantidade }}
        </span>
      </td>
      <td class="text-center">
        <p-cellEditor>
          <ng-template pTemplate="input">
            <input
              pInputText
              type="text"
              class="input-filters text-center"
              required
              #vlInput
              (click)="vlInput.select()"
              (keydown)="validateOnlyNumbers($event)"
              [(ngModel)]="produto.valor"
            />
          </ng-template>
          <ng-template pTemplate="output">
            {{ produto.valor | currency: 'BRL' }}
          </ng-template>
        </p-cellEditor>
      </td>
      <td class="text-center">
        <div class="flex align-items-center justify-content-center gap-2">
          <button
            *ngIf="!editing"
            pButton
            pRipple
            type="button"
            pInitEditableRow
            icon="pi pi-pencil"
            (click)="onRowEditInit(produto)"
            class="p-button-rounded p-button-text"
          ></button>
          <button
            *ngIf="editing"
            pButton
            pRipple
            type="button"
            pSaveEditableRow
            icon="pi pi-check"
            (click)="onRowEditSave(produto)"
            class="p-button-rounded p-button-text p-button-success mr-2"
          ></button>
          <button
            *ngIf="editing"
            pButton
            pRipple
            type="button"
            pCancelEditableRow
            icon="pi pi-times"
            (click)="onRowEditCancel(produto, ri)"
            class="p-button-rounded p-button-text p-button-danger"
          ></button>
        </div>
      </td>
      <td class="text-center">
        <div class="flex align-items-center justify-content-center gap-2">
          <button
            pButton
            pRipple
            type="button"
            icon="pi pi-trash"
            (click)="onRemoveProdutoVariacao.emit(produto)"
            class="p-button-rounded p-button-text p-button-danger"
          ></button>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>
<!-- TABELA DE VARIACOES SELECIONADAS -->

<div
  class="flex flex-direction-column align-items-center justify-content-center mt-3"
  *ngIf="variacoes.length === 0 && showVariacoes"
>
  <strong class="gray" style="font-size: 16px;">
    Nenhuma variação adicionada ainda...
  </strong>
</div>

<p-table
  #dt1
  dataKey="variacao_id"
  [rows]="5"
  [rowsPerPageOptions]="[5, 10, 15]"
  [paginator]="false"
  [totalRecords]="variacoes.length"
  *ngIf="variacoes.length && showVariacoes"
  [value]="variacoes"
  [globalFilterFields]="['descricao']"
  styleClass="p-datatable-customers p-datatable-striped container"
  [tableStyle]="{ 'min-width': '50rem' }"
>
  <ng-template pTemplate="caption">
    <div class="flex width-100">
      <span class="p-input-icon-right mr-auto width-100">
        <i
          *ngIf="filterActive"
          class="p-button-outlined p-button-rounded p-button-danger p-button-sm pi pi-times-circle text-red-500 cursor-pointer"
          (click)="clear(dt1, false)"
        ></i>
        <input
          #filterInput
          pInputText
          class="input-filters"
          type="text"
          (input)="filter($event.target.value, dt1, false)"
          placeholder="Filtrar"
        />
      </span>
    </div>
    <span class="flex justify-content-end mt-2">
      Total de <b>&nbsp;{{ variacoes.length }}&nbsp;</b> variações
    </span>
  </ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th style="width: 5rem" class="tr-header"></th>
      <th class="fs-small tr-header">Descrição</th>
      <th style="width: 5rem" class="tr-header">
        <button
          pButton
          pRipple
          type="button"
          icon="pi pi-trash"
          (click)="onRemoveAllVariacao.emit()"
          class="p-button-rounded p-button-text p-button-danger"
        ></button>
      </th>
    </tr>
  </ng-template>
  <ng-template
    pTemplate="body"
    let-variacao
    let-columns="columns"
    let-expanded="expanded"
    let-rowIndex="rowIndex"
  >
    <tr>
      <td>
        <button
          type="button"
          pButton
          pRipple
          [pRowToggler]="variacao"
          class="p-button-text p-button-rounded p-button-plain"
          [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
        ></button>
      </td>
      <td class="fs-small">{{ variacao.descricao }}</td>
      <td class="text-center">
        <button
          pButton
          pRipple
          type="button"
          icon="pi pi-trash"
          (click)="onRemoveVariacao.emit(variacao)"
          class="p-button-rounded p-button-text p-button-danger"
        ></button>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="rowexpansion" let-item_variacao>
    <tr>
      <td colspan="7">
        <div class="p-3">
          <p-table
            #dt2
            [value]="item_variacao.itens"
            dataKey="variacao_item_id"
            [rows]="5"
            [totalRecords]="item_variacao.itens.length"
            [rowsPerPageOptions]="[5, 10, 15]"
            [paginator]="true"
            [globalFilterFields]="['descricao']"
            styleClass="p-datatable-customers p-datatable-striped container"
          >
            <ng-template pTemplate="caption">
              <div class="flex width-100">
                <span class="p-input-icon-right mr-auto width-100">
                  <i
                    *ngIf="filterItensActive"
                    class="p-button-outlined p-button-rounded p-button-danger p-button-sm pi pi-times-circle text-red-500 cursor-pointer"
                    (click)="clear(dt2, true)"
                  ></i>
                  <input
                    #filterInputItens
                    pInputText
                    class="input-filters"
                    type="text"
                    (input)="filter($event.target.value, dt2, true)"
                    placeholder="Filtrar"
                  />
                </span>
              </div>
              <span class="flex justify-content-end mt-2">
                Total de
                <b>&nbsp;{{ item_variacao.itens.length }}&nbsp;</b> itens de
                variação
              </span>
            </ng-template>
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th class="fs-small tr-header">Descrição</th>
                <th style="width: 5rem" class="tr-header">
                  <button
                    pButton
                    pRipple
                    type="button"
                    icon="pi pi-trash"
                    (click)="onRemoveAllVariacaoItem.emit(item_variacao)"
                    class="p-button-rounded p-button-text p-button-danger"
                  ></button>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item>
              <tr>
                <td class="fs-small">{{ item.descricao }}</td>
                <td class="text-center">
                  <button
                    pButton
                    pRipple
                    type="button"
                    icon="pi pi-trash"
                    (click)="onRemoveVariacaoItem.emit(item)"
                    class="p-button-rounded p-button-text p-button-danger"
                  ></button>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="7">Nenhuma informação encontrada...</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="7">Nenhuma informação encontrada...</td>
    </tr>
  </ng-template>
</p-table>
